import { observer } from 'mobx-react-lite'
import { SingleItemSelector } from '@/components/SingleItemSelector'
import { Avatar } from '@/components/Avatar'
import { FormGroupContainer } from '@/components/FormContainer'
import { FormRow } from '@/components/Form'
import { AddUserToTeamDialog } from '@/features/user-management/AddUserToTeamDialog'
import { type AddUserToTeamDialogViewModel } from './AddUserToTeamDialogViewModel'

export interface AddUserToTeamDialogContainerProps {
  vm: AddUserToTeamDialogViewModel
}

export const AddUserToTeamDialogContainer = observer(
  function AddUserToTeamDialogContainer({
    vm,
  }: AddUserToTeamDialogContainerProps) {
    const testId = 'add-user-to-team'

    return (
      <AddUserToTeamDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        <FormRow>
          <FormGroupContainer
            label="Workspace"
            error={vm.validation.getError('workspace')}
          >
            <SingleItemSelector
              value={vm.workspace}
              itemOptions={vm.availableWorkspaces}
              itemPrefix={(item) => (
                <Avatar
                  subject={{
                    avatar: item?.branding.logos.icon,
                  }}
                  size={24}
                />
              )}
              onChange={vm.setWorkspace}
              itemToString={(item) => (item ? item.name : '')}
              placeholder="Select workspace"
              isDisabled={vm.submit.pending}
              testId={`${testId}-workspace-selector`}
            />
          </FormGroupContainer>
        </FormRow>

        <FormRow>
          <FormGroupContainer
            label="Team name"
            help="To which team do you want to add the user?"
            error={vm.validation.getError('team')}
          >
            <SingleItemSelector
              value={vm.team}
              itemOptions={vm.availableTeams}
              onChange={vm.setTeam}
              itemToString={(item) => (item ? item.name : '')}
              placeholder="Select team"
              isDisabled={vm.submit.pending || vm.fetchOptions.pending}
              testId={`${testId}-team-selector`}
            />
          </FormGroupContainer>
        </FormRow>

        <FormRow>
          <FormGroupContainer
            label="Team role"
            help="Which role should this user have?"
            error={vm.validation.getError('teamRole')}
          >
            <SingleItemSelector
              value={vm.teamRole}
              itemOptions={vm.teamRoles}
              onChange={vm.setTeamRole}
              itemToString={(item) => (item ? item.name : '')}
              placeholder="Select team role"
              isDisabled={vm.submit.pending || vm.fetchOptions.pending}
              testId={`${testId}-team-role-selector`}
            />
          </FormGroupContainer>
        </FormRow>
      </AddUserToTeamDialog>
    )
  },
)
